import { render, staticRenderFns } from "./ClusterItemCard.vue?vue&type=template&id=1183b984&"
import script from "./ClusterItemCard.vue?vue&type=script&lang=js&"
export * from "./ClusterItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ClusterItemCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports